// routes/_embedded.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_embedded')

export const handle = { name: 'embedded-layout' }

export function HydrateFallback() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
